@charset "UTF-8";

/* src/app/views/contract-cancellation/process-cancellation/process-cancellation.component.scss */
html {
  font-size: 16px;
}
body {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
  font-family: "Ford F-1", sans-serif;
  color: #102b4e;
}
.page-container {
  width: 100%;
  max-width: var(--app-page-max-width);
  margin: 0 auto 24px;
  padding: 0;
}
.process-cancellation-container.container {
  max-width: var(--app-page-max-width) !important;
}
.process-cancellation-container {
  background: #ffffff;
  border: 1px solid #dbe4f0;
  border-radius: 16px;
  box-shadow: 0 16px 36px rgba(18, 38, 63, 0.08);
  overflow: hidden;
}
.page-header {
  padding: 26px 36px 10px;
}
.page-header h1 {
  margin: 0 0 6px 0;
  color: var(--app-page-title-color);
  font-size: var(--app-page-title-size);
  line-height: var(--app-page-title-line-height);
  font-weight: 400;
}
.page-header .subtitle {
  font-size: 16px;
  color: #5f5f5f;
  line-height: 22px;
  margin-top: 0;
  margin-bottom: 0;
}
.process-cancellation-body {
  padding: 8px 24px 26px;
}
:host ::ng-deep p-card.process-cancellation-main-card > .p-card {
  border: 1px solid #dbe4f0;
  border-radius: 14px;
  box-shadow: 0 8px 20px rgba(16, 43, 78, 0.06);
  background: #ffffff;
}
:host ::ng-deep p-card.process-cancellation-main-card > .p-card > .p-card-header.process-main-header {
  display: flex;
  flex-direction: column;
  justify-content: center;
  min-height: 118px;
  padding: 0 !important;
}
:host ::ng-deep p-card.process-cancellation-main-card > .p-card > .p-card-body {
  padding: 0 !important;
}
:host ::ng-deep p-card.process-cancellation-main-card .process-main-heading {
  display: flex;
  flex-direction: column;
  justify-content: center;
  padding: 18px 24px 0 !important;
}
:host ::ng-deep p-card.process-cancellation-main-card .process-main-title {
  display: block;
  margin: 0;
  padding: 0 !important;
  line-height: 1.2;
}
:host ::ng-deep p-card.process-cancellation-main-card .process-main-subtitle {
  display: block;
  margin: 0;
  padding: 8px 0 0 !important;
  line-height: 1.35;
}
:host ::ng-deep p-card.process-cancellation-main-card .process-main-header .hr-margin-top {
  margin-top: 14px;
  margin-bottom: 0;
  margin-left: 24px;
  margin-right: 24px;
}
:host ::ng-deep p-card.process-cancellation-main-card > .p-card > .p-card-body > .p-card-content {
  padding: 10px 20px 24px !important;
}
.process-cancellation-form {
  display: flex;
  flex-direction: column;
  gap: 16px;
  border: none;
  border-radius: 0;
  background: transparent;
  padding: 0;
}
:host ::ng-deep p-card.process-cancellation-main-card p-card.mb-4 {
  display: block;
}
:host ::ng-deep p-card.process-cancellation-main-card p-card.mb-4 + p-card.mb-4 {
  margin-top: 8px;
}
:host ::ng-deep p-card.process-cancellation-main-card p-card.section-block > .p-card > .p-card-header {
  padding: 0 4px 10px !important;
}
:host ::ng-deep p-card.process-cancellation-main-card .section-title-align {
  margin: 0;
  padding-left: 8px;
}
:host ::ng-deep p-card.process-cancellation-main-card p-card.section-block > .p-card > .p-card-body > .p-card-content {
  padding: 0 !important;
}
:host ::ng-deep p-card.process-cancellation-main-card p-card.section-block--plan {
  position: relative;
  top: 14px;
}
:host ::ng-deep p-card.process-cancellation-main-card p-card.cancellation-reason-block {
  margin-top: 0;
}
:host ::ng-deep p-card.process-cancellation-main-card p-card.cancellation-reason-block > .p-card > .p-card-header {
  display: flex;
  align-items: center;
  min-height: 0;
  padding: 2px 4px 10px !important;
}
:host ::ng-deep p-card.process-cancellation-main-card .cancellation-reason-title {
  margin: 0;
  line-height: 1.2;
}
:host ::ng-deep p-card.process-cancellation-main-card p-card.mb-4 > .p-card {
  border: none !important;
  border-radius: 0 !important;
  background: transparent !important;
  box-shadow: none !important;
}
:host ::ng-deep p-card.process-cancellation-main-card p-card.mb-4 > .p-card > .p-card-body {
  padding: 16px 16px 6px !important;
}
.section-content-box {
  border: 1px solid #dbe4f0;
  border-radius: 14px;
  background: #ffffff;
  padding: 16px 18px;
}
.section-content-box--plan {
  display: flex;
  justify-content: center;
  align-items: center;
}
.section-content-box--plan .plan-details {
  width: 100%;
  margin: 0 auto;
}
.section-content-box--plan .hr-margin-top,
.section-content-box--consumption .hr-margin-top {
  margin-bottom: 0;
}
.section-content-box--consumption {
  padding: 18px;
}
h1 {
  font-size: 2.2rem;
  color: #333;
  margin-bottom: 0.5rem;
}
p {
  font-size: 1rem;
  color: #666;
  margin-bottom: 1rem;
}
p-card .title-left {
  padding-top: 0;
  margin-left: 0;
}
p-card .title-left-two {
  margin-left: 1rem;
}
p-card .subtitle-left {
  padding-top: 0.35rem;
  margin-left: 0;
}
p-card .space-left-two {
  margin-left: 0;
}
p-card .p-card-title {
  font-size: 1.2rem;
  font-weight: bold;
}
p-card .p-card-title-two {
  font-size: 1.1rem;
}
p-card .p-card-subtitle {
  color: #777;
  margin-bottom: 1rem;
  font-size: 0.9rem;
}
p-card .p-card-subtitle-two {
  color: #777;
  font-size: 0.9rem;
}
p-card .p-card-subtitle-three {
  color: #777;
  margin-bottom: 0.8rem;
  font-size: 0.9rem;
}
.plan-details {
  display: grid;
  grid-template-columns: repeat(1, minmax(0, 1fr));
  gap: 0.85rem;
}
@media (min-width: 768px) {
  .plan-details {
    grid-template-columns: repeat(5, minmax(0, 1fr));
  }
}
.plan-details .detail-box {
  background-color: #f0f4f8;
  border-radius: 0.5rem;
  border-radius: 10px;
  padding: 0.9rem;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: flex-start;
  width: 100% !important;
  min-width: 0;
  min-height: 84px;
}
.plan-details .detail-box span {
  margin-bottom: 0.4rem;
  font-size: 0.85rem;
  color: #777;
}
.plan-details .detail-box strong {
  font-size: 0.9rem;
  color: #190A4C;
  word-break: break-word;
}
.plan-details .detail-box.plan {
  background-color: #fafcff;
  border: 1px solid #e1eefd;
}
.plan-details .detail-box.price {
  background-color: #fafdfa;
  border: 1px solid #e1f1e1;
}
.plan-details .detail-box.debit {
  background-color: #fefafb;
  border: 1px solid #f8e3e5;
}
.plan-details .detail-box.sale-date {
  background-color: #fefcfa;
  border: 1px solid #f7eee3;
}
.plan-details .detail-box.contract-start {
  background-color: #fafcff;
  border: 1px solid #e3effc;
}
.title-icon {
  display: flex;
  align-items: center;
  font-size: 1.1rem;
  color: #333;
  flex-wrap: wrap;
  gap: 0.5rem;
}
.title-icon i {
  font-size: 1.2rem;
  color: #bbb;
  flex-shrink: 0;
}
.input-disabled:disabled {
  background-color: #F2F2F2 !important;
  color: #666464 !important;
  border-color: #BCBCBC !important;
  padding: 0.75rem 1rem;
  font-size: 1rem;
}
.date-space {
  margin-left: 0;
  padding: 0.25rem 0;
  margin-bottom: 0.35rem;
  max-width: 360px;
}
.date-space .input-disabled {
  width: 100%;
}
.consumption-table {
  border: 1px solid #d8e2ee;
  border-radius: 10px;
  overflow-x: auto;
  overflow-y: hidden;
  margin-bottom: 1.5rem;
}
.consumption-table > div {
  border-bottom: 1px solid #e0e6ef;
  border-right: 1px solid #e0e6ef;
  padding: 0.75rem 1rem;
  box-sizing: border-box;
  min-height: 52px;
}
.consumption-table > div:nth-child(5n) {
  border-right: none;
}
.consumption-table > div:nth-last-child(-n+5) {
  border-bottom: none;
}
.consumption-table > div.table-header {
  background-color: #f2f6fb;
  color: #3f4f66;
  font-weight: 600;
  font-size: 0.9rem;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.consumption-table > div.table-label {
  color: #4f5d70;
  background-color: #fdfdfd;
  text-align: left;
  font-weight: 600;
  display: flex;
  align-items: center;
  gap: 0.3rem;
}
.consumption-table > div.table-value {
  font-size: 0.95rem;
  word-break: break-word;
  text-align: center;
  display: flex;
  align-items: center;
  justify-content: center;
}
.consumption-table > div.table-input {
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  min-width: 180px;
}
.consumption-table > div.table-input input {
  width: 100%;
  max-width: 220px;
  text-align: center;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  padding: 0.5rem 0.75rem;
  font-size: 0.95rem;
  box-sizing: border-box;
}
@media (max-width: 767px) {
  .consumption-table > div {
    border-right: none;
  }
  .consumption-table > div:not(:last-child) {
    border-bottom: 1px solid #e0e0e0;
  }
  .consumption-table > div:last-child {
    border-bottom: none;
  }
  .consumption-table .table-value,
  .consumption-table .table-input {
    display: flex;
    align-items: center;
    justify-content: space-between;
    text-align: right;
  }
}
.blue-tooltip-arrow.p-tooltip .p-tooltip-text-wrapper .p-tooltip-text {
  background-color: #046cea;
  color: #ffffff;
  font-weight: bold;
  padding: 0.5rem 0.8rem;
  border-radius: 0.375rem;
  font-size: 0.9rem;
  white-space: nowrap;
  box-shadow: 0 0.25rem 0.375rem rgba(0, 0, 0, 0.1);
  max-width: fit-content;
}
.residual-final-card {
  padding: 0;
  margin-bottom: 0.75rem;
}
.residual-final-card .residual-title-align {
  margin: 0;
  padding-left: 0;
  line-height: 1.2;
}
.residual-final-card .residual-subtitle-align {
  margin: 2px 0 0;
  padding-left: 0;
  line-height: 1.35;
}
.residual-final-card .p-card-content {
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  padding-right: 0;
}
.residual-final-card input {
  width: 100%;
  max-width: 25rem;
  text-align: left;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  font-size: 1.1rem;
  padding: 0.75rem 1rem;
  margin-left: 0;
  margin-top: 4px;
  align-self: flex-start;
  box-sizing: border-box;
}
:host ::ng-deep p-card.residual-final-card > .p-card > .p-card-header {
  padding: 12px 16px 6px !important;
}
:host ::ng-deep p-card.residual-final-card > .p-card > .p-card-body > .p-card-content {
  padding: 0 16px 10px !important;
}
.hr-margin-top {
  margin-top: 1.5rem;
  margin-bottom: 1.6rem;
  border: 0;
  height: 1px;
  background: #c9d3e1;
}
.p-position,
.position {
  display: flex;
  flex-direction: row;
  gap: 1rem;
  padding: 0;
  flex-wrap: wrap;
  justify-content: space-between;
  align-items: flex-start;
}
@media (min-width: 768px) {
  .p-position,
  .position {
    gap: 2rem;
  }
}
.position > .field.position-two {
  flex: 1 1 320px;
  min-width: 260px;
  width: auto !important;
}
.p-position-two,
.position-two {
  display: flex;
  flex-direction: column;
  margin-left: 0;
  flex: 1;
}
.content-style {
  border: 1px solid #d7e1ec;
  overflow: hidden;
  border-radius: 12px;
  padding: 1.1rem 1.2rem;
  background: #ffffff;
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
}
.content-style .field {
  min-width: 0;
}
.input-cancellation,
.element-textarea {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  font-size: 1rem;
  padding: 0.75rem 1rem;
  margin-left: 0;
  margin-top: 0.5rem;
}
.input-email,
.ipca-and-rates {
  width: 100%;
  box-sizing: border-box;
  border: 1px solid #ccc;
  border-radius: 0.5rem;
  font-size: 1rem;
  padding: 0.75rem 1rem;
  margin-top: 0.5rem;
}
.element-textarea {
  height: 6rem;
  resize: vertical;
}
.char-counter {
  margin-left: 0;
  padding-left: 0;
  font-size: 0.75rem;
  color: #999999;
  margin-top: 0.25rem;
}
.space-rates {
  margin-left: 0;
}
.content-style-blue {
  border: 1px solid #cfe1fb;
  overflow: hidden;
  border-radius: 12px;
  background: #f7fbff;
  padding: 1.1rem 1.2rem;
}
.value-summary {
  margin-top: 1rem;
}
.value-summary .summary-rows {
  width: 100%;
  display: grid;
  grid-template-columns: 1fr;
  gap: 1rem;
  margin-bottom: 1rem;
}
@media (min-width: 768px) {
  .value-summary .summary-rows {
    grid-template-columns: minmax(0, 1fr) minmax(0, 1fr);
    gap: 2rem;
  }
}
.value-summary .summary-position {
  display: flex;
  flex-direction: column;
  margin-left: 0;
  min-width: 0;
  padding-left: 0;
  width: 100% !important;
}
.value-summary .value-right {
  align-items: flex-end;
  margin-right: 0;
  padding-right: 0;
}
.value-summary .summary-item {
  padding: 0.3rem 0;
  font-size: 0.95rem;
  color: #777;
  word-break: break-word;
  width: 100% !important;
}
.value-summary .summary-item.value {
  text-align: right;
  font-weight: bold;
  color: #333;
  font-size: 1rem;
}
.value-summary .summary-item.positive {
  color: #33A67A;
}
.value-summary .summary-item.negative {
  color: #BF1753;
}
.total-value-box {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 1rem;
  padding-bottom: 1rem;
}
.return-component {
  width: 100%;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: flex-start;
  align-items: flex-start;
  background-color: #ffffff;
  border: 2px solid #CAE0FB;
  border-radius: 0.5rem;
}
@media (min-width: 768px) {
  .return-component {
    flex-direction: column;
    justify-content: flex-start;
    align-items: flex-start;
  }
}
.return-label {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  margin-bottom: 0.5rem;
}
@media (min-width: 768px) {
  .return-label {
    margin-bottom: 0;
  }
}
.icon-style {
  font-size: 1.8rem;
  margin-right: 0.8rem;
  color: #026BEA;
}
.p-return-value {
  padding: 0.2rem 0;
  font-size: 1.1rem;
  color: #777;
  margin: 0;
}
.strong-return-value {
  text-align: left;
  font-size: 1.8rem;
  font-weight: 500;
  color: #026BEA;
  word-break: break-all;
}
.return-position {
  display: flex;
  justify-content: center;
  align-items: center;
  padding-top: 0.5rem;
  width: 100%;
}
.return-value-box {
  width: 100%;
  padding: 1rem;
  display: flex;
  flex-direction: column;
  align-items: flex-start;
  margin-top: 0.5rem;
}
@media (min-width: 768px) {
  .return-value-box {
    flex-direction: column;
    align-items: flex-start;
  }
}
.return-value-box i {
  font-size: 1.4rem;
  margin-right: 0.8rem;
  color: #BE1027;
  flex-shrink: 0;
}
.return-value-box span {
  padding: 0.2rem 0;
  font-size: 0.9rem;
  color: #BE1027;
  margin: 0;
  flex-grow: 1;
}
.return-value-box .return-value {
  width: auto;
  text-align: left;
  font-size: 0.9rem;
  font-weight: lighter;
  color: #BE1027;
  margin-top: 0.2rem;
  margin-left: 0;
  padding-left: 0;
}
@media (min-width: 768px) {
  .return-value-box .return-value {
    margin-top: 0;
    padding-left: 0;
    flex: 1;
  }
}
.return-value-box.invalid-value-box {
  background: #F6EFF3;
  border: 1px solid #E3A2AD;
  border-radius: 0.625rem;
  padding-right: 1.5rem;
}
.distribution-boxes {
  display: flex;
  flex-direction: column;
  gap: 1rem;
  padding: 1.5rem 0;
}
@media (min-width: 768px) {
  .distribution-boxes {
    flex-direction: row;
    justify-content: space-between;
    align-items: stretch;
    gap: 1.5rem;
  }
}
.distribution-boxes .distribution-box {
  border-radius: 0.5rem;
  padding: 1.5rem;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  align-items: flex-start;
  position: relative;
  flex: 1 1 320px;
  min-width: 0;
  width: 100% !important;
}
.distribution-boxes .distribution-box span {
  margin-bottom: 0.5rem;
  font-size: 0.9rem;
  color: #777;
}
.distribution-boxes .distribution-box strong {
  text-align: left;
  font-size: 1.6rem;
  font-weight: 500;
  color: #026BEA;
  overflow-wrap: anywhere;
}
.distribution-boxes .distribution-box .percentage {
  position: absolute;
  top: 0.8rem;
  right: 0.8rem;
  padding: 0.2rem 0.5rem;
  border-radius: 0.625rem;
  font-size: 0.8rem;
}
.distribution-boxes .distribution-box .color-ford {
  background-color: #D6E7FB;
  color: #026BEA;
}
.distribution-boxes .distribution-box .color-dealer {
  background-color: #E9F4FF;
  color: #A2CDFF;
}
.distribution-boxes .distribution-box.ford {
  border: 1px solid #D3E4FB;
  background: #EDF4FD;
  margin: 0;
}
.distribution-boxes .distribution-box.dealer {
  border: 1px solid #E7F1FF;
  background: #F4F9FF;
  margin: 0;
}
.button-position {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  margin-top: 1.5rem;
  padding: 2rem 1.2rem;
  gap: 1rem;
  width: 100%;
  min-height: 100px;
  border-top: 1px solid #dbe4f0;
}
@media (min-width: 992px) {
  .button-position {
    justify-content: center;
    gap: 1rem;
  }
}
.button-position div {
  display: flex;
  flex-wrap: wrap;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  width: auto;
}
@media (min-width: 992px) {
  .button-position div {
    width: auto;
  }
}
@media (max-width: 991.98px) {
  .process-cancellation-body {
    padding: 8px 16px 20px;
  }
  :host ::ng-deep p-card.process-cancellation-main-card > .p-card > .p-card-body > .p-card-content {
    padding: 10px 12px 18px !important;
  }
  .process-cancellation-form {
    padding: 12px;
    gap: 14px;
  }
  .plan-details {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }
}
.action-button,
.undo-action-button {
  width: 100%;
  max-width: 18rem;
  height: 3rem;
  border-radius: 0.625rem;
  margin-top: 1rem;
  font-size: 1rem;
}
.action-button-label,
.undo-action-button-label {
  font-size: 1rem;
  font-weight: 500;
  line-height: 1;
}
@media (min-width: 768px) {
  .action-button,
  .undo-action-button {
    width: auto;
    min-width: 8rem;
    max-width: none;
    margin-top: 0;
  }
}
.action-button {
  background: #046cea;
  border: 1px solid #046cea;
  padding: 1rem;
}
.action-button-label {
  color: #ffffff;
}
.action-button:hover {
  background: #044ea7;
}
.undo-action-button {
  background: #ffffff;
  border: 1px solid #046cea;
  margin-right: 0;
}
.undo-action-button-label {
  color: #046cea;
  margin-left: 0.3rem;
}
.undo-action-button:hover {
  background: #044ea7;
}
.undo-action-button:hover .undo-action-button-label {
  color: #ffffff;
}
.error-message {
  color: #666;
  font-size: 0.75rem;
  margin-top: 0.625rem;
  display: block;
  margin-left: 0;
  padding-left: 0;
  width: 100%;
  box-sizing: border-box;
}
input.ng-invalid,
textarea.ng-invalid {
  border-color: #be1027 !important;
}
.consumption-table .table-input input.ng-invalid {
  border-color: #be1027 !important;
}
.consumption-table .table-input .error-message {
  width: 90%;
  text-align: left;
  padding-left: 0;
  margin-top: 0.625rem;
  margin-left: 0;
}
.input-cancellation.ng-invalid,
.element-textarea.ng-invalid,
.input-email.ng-invalid,
.ipca-and-rates.ng-invalid {
  border-color: #be1027 !important;
}
.p-position-two .error-message,
.position-two .error-message {
  margin-top: 0.625rem;
  padding-left: 0;
  margin-left: 0;
  width: 100%;
}
.residual-final-card p-content .error-message {
  margin-top: 0.625rem;
  text-align: left;
  padding-left: 0;
  margin-left: 0;
  width: 100%;
}
@media (max-width: 575.98px) {
  html {
    font-size: 14px;
  }
  .process-cancellation-container {
    margin: 0 auto 16px;
    border-radius: 12px;
  }
  .page-header {
    padding: 18px 14px 8px;
  }
  .process-cancellation-body {
    padding: 8px 12px 16px;
  }
  .page-header h1 {
    font-size: 1.8rem;
  }
  .page-header .subtitle {
    font-size: 0.8rem;
  }
  p {
    font-size: 0.9rem;
  }
  .strong-return-value {
    font-size: 1.5rem;
  }
  .distribution-box strong {
    font-size: 1.4rem;
  }
  .error-message {
    font-size: 0.7rem;
    width: 100%;
  }
  .char-counter {
    margin-left: 0;
  }
}
@media (min-width: 1200px) {
  .process-cancellation-container {
    max-width: 1400px;
  }
  .page-header h1 {
    font-size: 2.5rem;
  }
  .strong-return-value {
    font-size: 2rem;
  }
  .distribution-box strong {
    font-size: 1.8rem;
  }
}
/*# sourceMappingURL=process-cancellation.component-NUUKARY5.css.map */
